export const VALIDATE_OTP_CODE_ENDPOINT = '/booking-portal/OTP/ValidateOTP';
